import { Medicine, MedicineBatch, StockMovement } from '../../types'

export function formatCurrency(amount: number) {
  return new Intl.NumberFormat('en-ZM', {
    style: 'currency',
    currency: 'ZMW',
    maximumFractionDigits: 2,
  }).format(amount)
}

/** True whenever inventory has reached its configured reorder threshold. */
export function isLowStock(medicine: Medicine) {
  return medicine.currentQuantity <= medicine.reorderLevel
}

export function isOutOfStock(medicine: Medicine) {
  return medicine.currentQuantity <= 0
}

/** Low-stock presentation excludes stockouts so dashboard and reports stay distinct. */
export function isLowStockOnly(medicine: Medicine) {
  return isLowStock(medicine) && !isOutOfStock(medicine)
}

export function isExpiringWithin(batch: MedicineBatch, days: number) {
  const today = startOfToday()
  const limit = new Date(today)
  limit.setDate(limit.getDate() + days)
  const expiry = new Date(`${batch.expiryDate}T23:59:59`)
  return expiry >= today && expiry <= limit && batch.quantityRemaining > 0
}

export function expiryAlertWindow(batch: MedicineBatch) {
  if (isExpired(batch)) return 'Expired' as const
  if (isExpiringWithin(batch, 30)) return '30 Days' as const
  if (isExpiringWithin(batch, 60)) return '60 Days' as const
  if (isExpiringWithin(batch, 90)) return '90 Days' as const
  return null
}

export function isExpired(batch: MedicineBatch) {
  return (
    new Date(`${batch.expiryDate}T23:59:59`) < startOfToday() &&
    batch.quantityRemaining > 0
  )
}

export function isToday(date: string) {
  return date.slice(0, 10) === new Date().toISOString().slice(0, 10)
}

export function movementLabel(movement: StockMovement) {
  const labels: Record<StockMovement['type'], string> = {
    Receipt: 'Stock In',
    Dispense: 'Dispensed',
    'Adjustment In': 'Adjustment',
    'Adjustment Out': 'Adjustment',
    'Return In': 'Returned',
    'Return Out': 'Returned',
    'Expired Disposal': 'Expired',
    Damaged: 'Damaged',
    Transfer: 'Transfer',
  }
  return labels[movement.type]
}

export function stockStatus(medicine: Medicine) {
  if (isOutOfStock(medicine)) return 'Out of stock'
  if (isLowStock(medicine)) return 'Low stock'
  return 'In stock'
}

function startOfToday() {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}
